import React, { FC, useEffect, useState } from 'react';

import { usePathname } from 'next/navigation';

import { SFHeaderFooterCategoryFooterViewModel } from '@api/index';

import {
  MobileHeaderRightColumnWrapper,
  MobileHeaderWrapper,
  MobileRectangle,
} from './MobileHeaderStyle';
import BrandLink from '../BrandLink';
import BasketLink from '../BasketLink';
import UserMenuButton from '../UserMenuButton';
import HamburgerMenu from '../HamburgerMenu';
import NavigationDrawer from '../NavigationDrawer';
import UserMenuDrawer from '../UserMenuDrawer';

interface IMobileHeader {
  data: SFHeaderFooterCategoryFooterViewModel['header'];
}

const MobileHeader: FC<IMobileHeader> = ({ data }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  const pathname = usePathname();

  useEffect(() => {
    setIsMenuOpen(false);
    setIsUserMenuOpen(isUserMenuOpen);
  }, [pathname, isUserMenuOpen]);

  const toggleMenuOpen = () => setIsMenuOpen((oldState) => !oldState);
  const toggleUserMenuOpen = () => setIsUserMenuOpen((oldState) => !oldState);

  return (
    <>
      <MobileHeaderWrapper>
        <BrandLink
          imageProps={{
            width: 100,
            height: 60,
          }}
        />
        <MobileHeaderRightColumnWrapper>
          <BasketLink />

          <MobileRectangle />
          <UserMenuButton
            isOpen={isUserMenuOpen}
            toogleMenuOpen={toggleUserMenuOpen}
          />
          <HamburgerMenu isOpen={isMenuOpen} toogleMenuOpen={toggleMenuOpen} />
        </MobileHeaderRightColumnWrapper>
      </MobileHeaderWrapper>
      <NavigationDrawer
        data={data}
        isVisible={isMenuOpen}
        onClose={toggleMenuOpen}
      />
      <UserMenuDrawer isVisible={isUserMenuOpen} onClose={toggleUserMenuOpen} />
    </>
  );
};

export default MobileHeader;
